import React from "react";
import { Page, Form } from "ui/components";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { Auth } from "services/action";

const UserScreen = () => {
  const Dispatch = useDispatch();

  const [name, setName] = React.useState(null);
  const [phone, setPhone] = React.useState(null);

  const [errorName, setErrorName] = React.useState(false);
  const [errorPhone, setErrorPhone] = React.useState(false);
  const [errorFormatPhone, setErrorFormatPhone] = React.useState(false);

  const $onSave = async (e) => {
    if (!name) {
      setErrorName(true);
    }

    if (!phone) {
      setErrorPhone(true);
    }

    setTimeout(function () {
      setErrorName(false);
      setErrorPhone(false);
      setErrorFormatPhone(false);
    }, 10000);

    let c = await $checkFormat(phone);

    const payload = {
      name: name,
      phone: c,
    };

    if (name && c) {
      await Dispatch(Auth.$setSession(payload));
    }
  };

  const $checkFormat = async (e) => {
    let first = phone?.substring(0, 2);

    if (phone) {
      if ((first !== "08" && first !== "62") || phone?.length < 10) {
        setErrorFormatPhone(true);

        setTimeout(function () {
          setErrorFormatPhone(false);
        }, 10000);
        return;
      } else if (first === "62" && phone[2] !== "8") {
        setErrorFormatPhone(true);

        setTimeout(function () {
          setErrorFormatPhone(false);
        }, 10000);
        return;
      }
    }

    return phone;
  };

  return (
    <Page
      title="Data Driver"
      full
      hasFooter
      footer={
        <Button
          type="submit"
          variant="primary"
          className="pe-4 ps-4 rounded w-100"
          onClick={() => $onSave()}
        >
          Simpan Data
        </Button>
      }
    >
      <div className="bg-white p-3">
        <div className="mb-3">
          <Form.Input
            required
            label="Nama"
            type="text"
            mb0
            value={name || ""}
            onChange={(e) => setName(e.target.value)}
            error={errorName}
          />
          {errorName ? (
            <div
              className="invalid-feedback mt-n1"
              style={{ display: "block" }}
            >
              Nama harus diisi
            </div>
          ) : null}
        </div>

        <div className="mb-3">
          <Form.Input
            required
            mb0
            label="No. Hp"
            type="phone"
            value={phone || ""}
            onChange={(e) => setPhone(e.target.value)}
            error={errorPhone || errorFormatPhone}
          />
          {errorPhone ? (
            <div
              className="invalid-feedback mt-n1"
              style={{ display: "block" }}
            >
              No. Hp harus diisi
            </div>
          ) : null}

          {errorFormatPhone ? (
            <div
              className="invalid-feedback mt-n1"
              style={{ display: "block" }}
            >
              Format nomor tidak valid
            </div>
          ) : null}
        </div>
      </div>
    </Page>
  );
};

export default UserScreen;
